import { useEffect, useState } from 'react';

export function useDebounce(
    func: () => any,
    args: Array<any>,
    delay: number = 500,
) {
    const [timeoutId, setTimeoutId] = useState<number>();

    useEffect(() => {
        if (timeoutId !== undefined) clearInterval(timeoutId);

        setTimeoutId(
            //@ts-ignore
            setTimeout(() => {
                func();
            }, delay),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, args);
}
